export default "__VITE_ASSET__Ch8btdMJ__"